/*
 * @Author: Scarlett Xiao
 * @Date: 2022-02-14 15:34:05
 * @LastEditors: dong
 * @LastEditTime: 2024-01-31 15:26:36
 */
export function loadBMap(funcName) {
  var script = document.createElement("script");

  // RqzGvp45Gx4dvBR1i8b20W9X4PDcO2B8
  // rXAeMrbBwGdyIzhqlFuYfOkbLzk0q3Or  公司账号
  script.src = "https://api.map.baidu.com/api?type=webgl&v=2.0&ak=VfCQlwIEdZUSwPMUC0Ij1Lsyo7yUAY4f&callback=" + funcName;
  // script.src = "http://api.map.baidu.com/api?v=2.0&ak=4SohswS24sY2IWAiMmntfpR398zEXjVm&callback=" + funcName;
  setTimeout(() => {
    document.body.appendChild(script);
  }, 0);

}